import React from 'react';
import * as Icons from 'lucide-react';

export const DifferentialCard = ({ differential }) => {
  const IconComponent = Icons[differential.icon] || Icons.Star;
  
  return (
    <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
      <div className="w-14 h-14 bg-[#00B4D8]/10 rounded-full flex items-center justify-center mb-4">
        <IconComponent className="w-7 h-7 text-[#00B4D8]" />
      </div>
      <h3 className="text-xl font-bold text-gray-900 mb-2">{differential.title}</h3>
      <p className="text-gray-600">{differential.description}</p>
    </div>
  );
};
